import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export function NumbersOnlyValidator(control: AbstractControl): ValidationErrors | null {
  if (Validators.pattern('^[0-9]*$')(control)) {
    return {
      numbersOnly: true,
    };
  }
  return null;
}
